document.addEventListener('DOMContentLoaded', function () { 

  /* ==========================================
     COUNTDOWN TIMER
  ========================================== */
  function updateBindingsCountdown() {
    const countdownEl = document.querySelector("#bindings-countdown");
    if (!countdownEl) return;

    const targetDate = new Date(countdownEl.dataset.target).getTime();
    const now = new Date().getTime();
    const distance = targetDate - now;

    if (distance < 0) {
      countdownEl.textContent = "Offer expired";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    countdownEl.textContent = `Ends in ${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  function initBindingsCountdown() {
    updateBindingsCountdown();
    clearInterval(window.bindingsInterval);
    window.bindingsInterval = setInterval(updateBindingsCountdown, 1000);
  }

  initBindingsCountdown();
  document.addEventListener('variant:changed', initBindingsCountdown);
  document.addEventListener('shopify:section:load', initBindingsCountdown);


  /* ==========================================
     SAFE CART HELPERS
  ========================================== */

  async function getCart() {
    return fetch('/cart.js')
      .then(r => r.json())
      .catch(() => null);
  }

  async function waitForCartReady(maxAttempts = 12) {
    let attempts = 0;
    let previousCount = -1;

    while (attempts < maxAttempts) {
      const cart = await getCart();
      if (!cart) break;

      if (cart.items.length !== previousCount) {
        previousCount = cart.items.length;
        attempts++;
        await new Promise(r => setTimeout(r, 120));
        continue;
      }

      return cart;
    }

    return getCart();
  }

  async function safeAddToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      });

      if (!response.ok) throw new Error("Error adding item to cart");
      return response.json();
    } catch (e) {
      console.error("🛑 Free Bindings Add Error:", e);
      return null;
    }
  }


  /* ==========================================
     IMPACT OVERRIDE: GLOBAL CAPTURE HANDLER
  ========================================== */

  window.__renounFreeBindingsLock = false;

  document.addEventListener('submit', async function (event) {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    const bindingsBlock = document.querySelector('.free-bindings-block');
    if (!bindingsBlock || bindingsBlock.classList.contains('tohide')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (window.__renounFreeBindingsLock) return;
    window.__renounFreeBindingsLock = true;

    const formData = new FormData(form);
    const skiVariantId = formData.get('id');

    if (!skiVariantId) {
      console.error("🛑 Free Bindings Error: Ski variant ID not found.");
      window.__renounFreeBindingsLock = false;
      return;
    }

    const selectedBinding = document.querySelector('input[name="binding_choice"]:checked:not(:disabled)');
    let bindingVariant = selectedBinding ? selectedBinding.value : "none";

    if (bindingVariant.includes("_")) {
      bindingVariant = bindingVariant.split("_")[0];
    }

    const shouldAddBinding = bindingVariant !== "none";

    const skiAddResult = await safeAddToCart(skiVariantId);

    if (!skiAddResult) {
      window.__renounFreeBindingsLock = false;
      return;
    }

    if (shouldAddBinding) {
      await safeAddToCart(bindingVariant);
    }

    await waitForCartReady();

    document.dispatchEvent(new CustomEvent('cart:refresh'));


    /* ==========================================
       FORCE OPEN IMPACT CART DRAWER
    ========================================== */

    setTimeout(() => {
      const drawer = document.querySelector('cart-drawer#cart-drawer');

      if (drawer) {
        drawer.setAttribute('open', '');
        drawer.style.opacity = "1";
        drawer.style.visibility = "visible";
      } else {
        console.warn("Cart drawer element not found.");
      }
    }, 300);


    setTimeout(() => {
      window.__renounFreeBindingsLock = false;
    }, 300);

  }, true);

});